module.exports = __webpack_public_path__ + "img/lock-open.3fbac4d5.svg";